import { render, staticRenderFns } from "./ScoreContent.vue?vue&type=template&id=4d4f02a4&scoped=true"
import script from "./ScoreContent.vue?vue&type=script&lang=js"
export * from "./ScoreContent.vue?vue&type=script&lang=js"
import style0 from "./ScoreContent.vue?vue&type=style&index=0&id=4d4f02a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4f02a4",
  null
  
)

export default component.exports